import { D_House, D_FolderOpen, D_CalendarStar, D_FileLines, D_FileCircleCheck, D_Book, D_HandsHoldingDollar, D_MessageHeart } from 'hosman-material';
import { SPONSORSHIP_MAX_BONUS } from '../../../../../shared/helpers/sponsorshipHelper';

export const navigation = ({ sale, visitsToCome, visitsWithReport, offers }) => {
  let items = [];

  if (!sale.id) return items;

  const BASE_PATH = `ventes/${sale.id}`

  items = [
    { name: 'Dossier de vente', path: `${BASE_PATH}/dossier-de-vente`, icon: D_FolderOpen },
    { name: 'Mon planning', path: `${BASE_PATH}/planning`, icon: D_CalendarStar, count: visitsToCome.length },
    { name: 'Comptes-rendus', path: `${BASE_PATH}/comptes-rendus`, icon: D_FileLines, count: visitsWithReport.length },
    { name: 'Mes offres', path: `${BASE_PATH}/offres`, icon: D_FileCircleCheck, count: offers.length },
    { name: 'Conseils immo', path: `${BASE_PATH}/conseils-immo`, icon: D_Book },
    { name: 'Parrainez un proche', subtitle: `Gagnez jusqu'à ${SPONSORSHIP_MAX_BONUS.toLocaleString('fr-FR')}€ !`, path: `${BASE_PATH}/parrainage`, icon: D_MessageHeart, gtmEventParams: 'click_parrainage_menu' }
  ]

  if (sale.isEstimated && (sale.property?.kind !== 'parking_spot' || sale.state !== 'awaiting_term_signature')) items.splice(0, 0, { name: 'Mon estimation', path: `${BASE_PATH}/mon-estimation`, icon: D_HandsHoldingDollar })
  if (sale.state === 'awaiting_term_signature' && !sale.mandateSigned) items.splice(0, 0, { name: 'Mon mandat', path: `${BASE_PATH}/mon-mandat`, icon: D_FileLines })
  sale.mandateSigned && items.splice(0, 0, { name: 'Ma vente', path: BASE_PATH, icon: D_House })

  return items;
}
